import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener("DOMContentLoaded", () => {
	const swiper = new Swiper(".fj-slider", {
		spaceBetween: 20,
		slidesPerGroup: 1,
		loop: false,
		slidesPerView: 1,
		scrollbar: {
			el: ".js-swiper-scrollbar",
			draggable: true,
			snapOnRelease: true,
		},
		breakpoints: {
			768: { slidesPerView: 2, spaceBetween: 30 },
			1200: { slidesPerView: 3, spaceBetween: 40 },
		},
	});

	window.addEventListener("resize", () => {
		swiper.update();
	});
});
